import React, { useState } from 'react';
import './EditContent.css';
import './HomePage.css';

const EditContent: React.FC = () => {
  const [activeSection, setActiveSection] = useState('banner');
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [userRole] = useState('Super Admin');
  const [searchQuery, setSearchQuery] = useState('');
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const [bannerData] = useState([{ content: "Bring harmony to team expenses with budget limits and real-time monitoring." }]);

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    window.location.href = '/';
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchFocus = () => {
    setShowSearchDropdown(true);
  };

  const handleSearchBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (e.relatedTarget && (e.relatedTarget as HTMLElement).closest('.search-results-dropdown')) {
      return;
    }
    setTimeout(() => setShowSearchDropdown(false), 200);
  };

  const clearSearch = () => {
    setSearchQuery('');
    setShowSearchDropdown(false);
  };

  return (
    <>
      {/* Header - Exact same as HomePage */}
      <header className="main-header" style={{overflow: 'visible'}}>
        <div className="container" style={{overflow: 'visible'}}>
          <div className="header-content" style={{overflow: 'visible'}}>
            {/* Logo */}
            <div className="logo-container">
              <a href="/home" className="logo">
                <img src="/assets/images/jwil-logo.svg" alt="JWIL Logo" className="logo-img" />
              </a>
            </div>

            {/* Search Bar */}
            <div className="search-container">
              <div className="search-box">
                <img src="/assets/images/call.svg" alt="Call Icon" className="search-icon-img" />
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search contacts..."
                  value={searchQuery}
                  onChange={handleSearchChange}
                  onFocus={handleSearchFocus}
                  onBlur={handleSearchBlur}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setShowSearchDropdown(true);
                  }}
                />
                <button type="button" className="clear-search-btn" onClick={clearSearch}>×</button>
                <div className="search-results-dropdown" style={{
                  display: showSearchDropdown ? 'block' : 'none',
                  position: 'absolute',
                  top: '100%',
                  left: '0',
                  right: '0',
                  background: 'white',
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                  zIndex: 1000,
                  maxHeight: '300px',
                  overflowY: 'auto'
                }}>
                  <ul className="search-results-list">
                    <li className="search-result-item">
                      <div className="result-info">
                        <p className="result-name">Anoop Sharma</p>
                        <p className="result-title">Software Developer</p>
                        <p className="result-contact">anoop.sharma@jwil.com • +91 5454578678</p>
                      </div>
                      <div className="result-ext">O33</div>
                    </li>
                    <li className="search-result-item active">
                      <div className="result-info">
                        <p className="result-name">Prasenjit Mukherjee</p>
                        <p className="result-title">Head IT & Digital</p>
                        <p className="result-contact">prasenjit.mukherjee@jwil.com • +91 9876543210</p>
                      </div>
                      <div className="result-ext">O42</div>
                    </li>
                    <li className="search-result-item">
                      <div className="result-info">
                        <p className="result-name">Manoj Kumar Mishra</p>
                        <p className="result-title">Engineering Team</p>
                        <p className="result-contact">manoj.mishra@jwil.com • +91 8765432109</p>
                      </div>
                      <div className="result-ext">O15</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Ticker */}
            <div className="ticker-bar">
              <div className="ticker-content">
                <div className="ticker-text-wrapper">
                  <p className="ticker-text">{bannerData[0]?.content || "Bring harmony to team expenses with budget limits and real-time monitoring."}</p>
                </div>
                <span className="icon-edit"></span>
              </div>
            </div>

            {/* User Profile */}
            <div className="user-profile" style={{overflow: 'visible'}}>
              <div className="user-greeting">
                <span>Good Morning:</span>
                <p>Purnendu Jha</p>
              </div>
              <div className="user-avatar" onClick={() => {
                setShowProfileDropdown(!showProfileDropdown);
              }}>
                <img src="/assets/images/profile-avatar.jpg" alt="User Avatar" className="avatar-img" />
                {showProfileDropdown && (
                  <div 
                    className="profile-dropdown-portal"
                    style={{
                      position: 'absolute',
                      top: '110%',
                      right: '-10px',
                      background: 'white',
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                      minWidth: '180px',
                      zIndex: 99999,
                      padding: '8px 0'
                    }}
                  >
                    <div className="dropdown-arrow" style={{
                      position: 'absolute',
                      top: '-8px',
                      right: '20px',
                      width: '0',
                      height: '0',
                      borderLeft: '8px solid transparent',
                      borderRight: '8px solid transparent',
                      borderBottom: '8px solid white'
                    }}></div>
                    {(userRole !== 'Employee') && (
                      <button className="dropdown-item" onClick={() => window.location.href = '/edit-content'} style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        width: '100%',
                        padding: '12px 16px',
                        border: 'none',
                        background: 'none',
                        textAlign: 'left',
                        fontSize: '14px',
                        color: '#333',
                        cursor: 'pointer'
                      }}>
                        <i className="icon-edit"></i>
                        Edit
                      </button>
                    )}
                    {userRole === 'Super Admin' && (
                      <button className="dropdown-item" onClick={() => console.log('User Management')} style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        width: '100%',
                        padding: '12px 16px',
                        border: 'none',
                        background: 'none',
                        textAlign: 'left',
                        fontSize: '14px',
                        color: '#333',
                        cursor: 'pointer'
                      }}>
                        <i className="icon-users"></i>
                        User Management
                      </button>
                    )}
                    <button className="dropdown-item logout" onClick={handleLogout} style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                      width: '100%',
                      padding: '12px 16px',
                      border: 'none',
                      background: 'none',
                      textAlign: 'left',
                      fontSize: '14px',
                      color: '#dc3545',
                      cursor: 'pointer',
                      borderTop: '1px solid #e9ecef'
                    }}>
                      <i className="icon-logout"></i>
                      Logout
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="edit-content-main">
        <div className="container">
          <div className="edit-content-layout">
            {/* Left Sidebar */}
            <aside className="edit-sidebar">
              <h3>Content Sections</h3>
              <nav className="section-nav">
                <button 
                  className={`section-btn ${activeSection === 'banner' ? 'active' : ''}`}
                  onClick={() => setActiveSection('banner')}
                >
                  <i className="icon-banner"></i>
                  Banner/Ticker
                </button>
                <button 
                  className={`section-btn ${activeSection === 'ceo' ? 'active' : ''}`}
                  onClick={() => setActiveSection('ceo')}
                >
                  <i className="icon-user"></i>
                  CEO Message
                </button>
                <button 
                  className={`section-btn ${activeSection === 'applications' ? 'active' : ''}`}
                  onClick={() => setActiveSection('applications')}
                >
                  <i className="icon-apps"></i>
                  Applications
                </button>
                <button 
                  className={`section-btn ${activeSection === 'updates' ? 'active' : ''}`}
                  onClick={() => setActiveSection('updates')}
                >
                  <i className="icon-news"></i>
                  JWIL Updates
                </button>
                <button 
                  className={`section-btn ${activeSection === 'policies' ? 'active' : ''}`}
                  onClick={() => setActiveSection('policies')}
                >
                  <i className="icon-document"></i>
                  Company Policies
                </button>
                <button 
                  className={`section-btn ${activeSection === 'events' ? 'active' : ''}`}
                  onClick={() => setActiveSection('events')}
                >
                  <i className="icon-calendar"></i>
                  Events
                </button>
              </nav>
            </aside>

            {/* Main Edit Area */}
            <div className="edit-main-area">
              <div className="edit-header">
                <h2>
                  {activeSection === 'banner' && 'Edit Banner/Ticker'}
                  {activeSection === 'ceo' && 'Edit CEO Message'}
                  {activeSection === 'applications' && 'Edit Applications'}
                  {activeSection === 'updates' && 'Edit JWIL Updates'}
                  {activeSection === 'policies' && 'Edit Company Policies'}
                  {activeSection === 'events' && 'Edit Events'}
                </h2>
                <div className="edit-actions">
                  <button className="btn-secondary">Cancel</button>
                  <button className="btn-primary">Save Changes</button>
                </div>
              </div>

              <div className="edit-content-area">
                {/* Banner Section */}
                {activeSection === 'banner' && (
                  <div className="edit-section">
                    <div className="form-group">
                      <label htmlFor="bannerText">Banner Text</label>
                      <textarea 
                        id="bannerText"
                        className="form-control"
                        rows={3}
                        placeholder="Enter banner/ticker text..."
                        defaultValue="Bring harmony to team expenses with budget limits and real-time monitoring."
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="bannerVisible">Visibility</label>
                      <div className="checkbox-group">
                        <input type="checkbox" id="bannerVisible" defaultChecked />
                        <label htmlFor="bannerVisible">Show banner on homepage</label>
                      </div>
                    </div>
                  </div>
                )}

                {/* CEO Message Section */}
                {activeSection === 'ceo' && (
                  <div className="edit-section">
                    <div className="form-group">
                      <label htmlFor="ceoTitle">Title</label>
                      <input 
                        type="text" 
                        id="ceoTitle"
                        className="form-control"
                        placeholder="Enter title..."
                        defaultValue="Message from MD & CEO"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="ceoMessage">Message Content</label>
                      <textarea 
                        id="ceoMessage"
                        className="form-control"
                        rows={6}
                        placeholder="Enter CEO message..."
                        defaultValue="Welcome to our company portal. We are committed to excellence and innovation..."
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="ceoImage">CEO Image</label>
                      <div className="file-upload">
                        <input type="file" id="ceoImage" accept="image/*" />
                        <label htmlFor="ceoImage" className="file-upload-label">
                          <i className="icon-upload"></i>
                          Choose Image
                        </label>
                      </div>
                    </div>
                  </div>
                )}

                {/* Applications Section */}
                {activeSection === 'applications' && (
                  <div className="edit-section">
                    <div className="applications-list">
                      <div className="list-header">
                        <h4>Application Links</h4>
                        <button className="btn-add">
                          <i className="icon-plus"></i>
                          Add Application
                        </button>
                      </div>
                      <div className="app-items">
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => (
                          <div key={item} className="app-item">
                            <div className="app-info">
                              <input 
                                type="text" 
                                className="form-control"
                                placeholder="Application name..."
                                defaultValue={`Application ${item}`}
                              />
                              <input 
                                type="url" 
                                className="form-control"
                                placeholder="Application URL..."
                                defaultValue={`https://app${item}.jwil.com`}
                              />
                            </div>
                            <div className="app-actions">
                              <button className="btn-icon btn-edit">
                                <i className="icon-edit"></i>
                              </button>
                              <button className="btn-icon btn-delete">
                                <i className="icon-delete"></i>
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* Other sections placeholder */}
                {(activeSection === 'updates' || activeSection === 'policies' || activeSection === 'events') && (
                  <div className="edit-section">
                    <div className="content-list">
                      <div className="list-header">
                        <h4>
                          {activeSection === 'updates' && 'JWIL Updates'}
                          {activeSection === 'policies' && 'Company Policies'}
                          {activeSection === 'events' && 'Events'}
                        </h4>
                        <button className="btn-add">
                          <i className="icon-plus"></i>
                          Add New
                        </button>
                      </div>
                      <div className="content-items">
                        <p>Content management for {activeSection} will be implemented here.</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer - Exact same as HomePage */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <img src="/assets/images/jwil-logo.svg" alt="JWIL Logo" className="footer-logo-img" />
            </div>
            <div className="footer-links">
              <a href="#" className="footer-link">Privacy Policy</a>
              <a href="#" className="footer-link">Terms of Service</a>
              <a href="#" className="footer-link">Contact Us</a>
            </div>
            <div className="social-icons">
              <a href="#" className="social-icon" aria-label="Facebook">
                <i className="icon-facebook"></i>
              </a>
            </div>
            <div className="copyright">
              &copy; Copyright 2024 All Rights Reserved by JWIL
            </div>
          </div>
        </div>
      </footer>

      {/* Floating Chat Boat Icon */}
      <div className="floating-chat-boat">
        <button className="chat-boat-btn" aria-label="Chat Support" title="Chat with us">
          <img src="/assets/images/chat-boat.svg" alt="Chat Boat Icon" className="chat-boat-icon" />
        </button>
      </div>
    </>
  );
};

export default EditContent;
